// paymentSlice.js
import { createSlice } from '@reduxjs/toolkit';

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    paymentResponse: null,
  },
  reducers: {
    setPaymentResponse: (state, action) => {
      state.paymentResponse = action.payload;
    },
  },
});

export const { setPaymentResponse } = paymentSlice.actions;
export default paymentSlice.reducer;
